import styles from "./styles.module.scss";
import { CoachingToolsItemBase, CoachingToolsItemBaseProps } from "../ItemBase/CoachingToolsItemBase";

export interface CoachingToolsItemProps extends Omit<CoachingToolsItemBaseProps, "children" | "accent"> {
	name: string;
}

export const CoachingToolsItem = ({ name, ...props }: CoachingToolsItemProps) => {
	return (
		<CoachingToolsItemBase {...props}>
			<p className={styles["item__name"]}>{name}</p>
		</CoachingToolsItemBase>
	);
};
